export default __webpack_public_path__ + "static/media/phone.0ca405c4.svg";